import {Component, OnInit, ViewChild} from '@angular/core';
import {PageDoc} from "../../dto/PageDoc";

import {EditorBO} from "../bo/EditorBO";
import {NgxSuneditorComponent} from "ngx-suneditor";

@Component({
  selector: 'app-new-page',
  templateUrl: './new-page.component.html',
  styleUrls: ['./new-page.component.css']
})
export class NewPageComponent implements OnInit {

  ngOnInit(): void {

  }



}
